import React from 'react';
import useAsync from 'react-use/esm/useAsync';
import { InfoCard, Progress, ResponseErrorPanel } from '@backstage/core-components';

type SolanaStatus = {
  blockHeight: number;
  syncStatus: 'ok' | 'not ok';
  rpcHealthy: boolean;
};

export const SolanaStatusCard = () => {
  const { value, loading, error } = useAsync<SolanaStatus>(async () => {
    const RPC_URL = 'https://solana-rpc.publicnode.com';

    // 1. Проверка здоровья RPC
    let rpcHealthy = false;
    try {
      const healthRes = await fetch(RPC_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          jsonrpc: '2.0',
          id: 1,
          method: 'getHealth',
        }),
      });
      const healthData = await healthRes.json();
      rpcHealthy = healthData.result === 'ok';
    } catch {
      rpcHealthy = false;
    }

    // 2. Получаем последний блок
    const blockRes = await fetch(RPC_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        jsonrpc: '2.0',
        id: 1,
        method: 'getBlockHeight',
      }),
    });
    const blockData = await blockRes.json();
    const blockHeight = blockData.result;

    // 3. Sync status (на основе health)
    const syncStatus: 'ok' | 'not ok' = rpcHealthy ? 'ok' : 'not ok';

    return {
      blockHeight,
      syncStatus,
      rpcHealthy,
    };
  }, []);

  if (loading) return <Progress />;
  if (error) return <ResponseErrorPanel error={error} />;

  return (
    <InfoCard title="Solana Node Status">
      <p><strong>RPC Healthy:</strong> {value?.rpcHealthy ? '✅ OK' : '❌ Not Healthy'}</p>
      <p><strong>Sync Status:</strong> {value?.syncStatus}</p>
      <p><strong>Block Height:</strong> {value?.blockHeight}</p>
    </InfoCard>
  );
};

